import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BaseService } from 'app/@core/services/base.service';
import { StorageService } from "app/@core/services/storage.service";
import { finalize} from 'rxjs/operators';
import { ColumnFilterComponent } from '../column-filter/column-filter.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UtilitiesService } from 'app/@core/services/utilities.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'column-manager',
  styleUrls: ['./column-manager.component.scss'],
  templateUrl: './column-manager.component.html',
})
export class ColumnManagerterComponent implements OnInit {
  @Output() changed = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  @Input() menuColumns:any;
  @Input() tableSettingKey = '';

//--------------------- @ViewChild Section ---------------------
  @ViewChild(ColumnFilterComponent) columnFilterComponent!: ColumnFilterComponent;

  // --------------------- Variable Section ---------------------
  isChangedAnyThing = false;
  isRestoring: boolean = false;
  columnObj: any = {
    userId: localStorage.getItem('companyUserId'),
    json: [],
    type: 'Custom',
    page: '',
    isDefault: true,
    presetName: "string",
    filterTableId: 0,
    isView: false,
    companyId: this.storageService.getCompanyID(),
    tableId: 0
  }

   columnObjView: any = {
    userId: localStorage.getItem('companyUserId'),
    json: [],
    type: 'Custom',
    page: '',
    isDefault: true,
    presetName: "string",
    filterTableId: 0,
    companyId: this.storageService.getCompanyID()
  }
  isAllSelected = false;

  //--------------------- Newly Added Code For Column Preset ---------------------
  editPresetTableFilterIDGet: any = null
  presetName: any;
  isDefaultset: any;
  filterTableID: any
  presetNameArray: any = [];
  presetNameArrayDefault: any = [];
  defaultPresetsName: any;
  formBool = false;
  formData: any;
  addAssetModal?: BsModalRef;
  editpresettableFilterId: any;
  assetData: any;


  constructor(
    public requestService: BaseService,
    public storageService: StorageService,
    private toaster: ToastrService,
    private modalService: BsModalService,
    public utilityService: UtilitiesService,

  ) {
  }
  ngOnInit(): void {
    let presentName:any = localStorage.getItem("presetName")
    let presetNameDefault:any = localStorage.getItem("presetNameDefault")
    this.presetNameArray = JSON.parse(presentName)
    this.presetNameArrayDefault = JSON.parse(presetNameDefault)
    if (this.presetNameArray.length > 0) {
      this.presetNameArray.map((x:any) => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    if (this.presetNameArrayDefault.length > 0) {
      this.presetNameArrayDefault.map((x:any) => {
        if (x.isDefault === true) {

          this.defaultPresetsName = x.presetName

        }
      })
    }

    this.menuColumns = this.normalizeMenuColumns(this.menuColumns);
    this.isAllSelected = this.isAllselectSlected();
  }

  toggleColumn(columnItem:any) {
    this.isChangedAnyThing = true;
    columnItem['isShowColumn'] = !columnItem['isShowColumn'];
    this.isAllSelected = this.isAllselectSlected();
  }

  isAllselectSlected() {
    return this.menuColumns.every((item:any) => item.isShowColumn)
  }


  selectAll(event:any) {
    this.isAllSelected = event.target.checked;
    this.isChangedAnyThing = true;
    this.menuColumns.map((item:any) => {
      item.isShowColumn = event.target.checked;
      return item;
    })
  }

  
  resetDefault() {
    this.isRestoring = true;
    this.requestService.getTableSettings(this.tableSettingKey, false).pipe(
      finalize(() => {
        this.isRestoring = false;
      })
    ).subscribe(response => {
      this.menuColumns = JSON.parse(response.defaultJson);
    });
    
    this.isAllSelected = this.isAllselectSlected();

    this.requestService.getTableSettings(this.tableSettingKey, true).pipe(
      finalize(() => {
        this.isRestoring = false;
      })
    ).subscribe((response) => {
      this.menuColumns = JSON.parse(response.defaultJson);
      this.isAllSelected = this.isAllselectSlected();
    })
  }


  drop(event: CdkDragDrop<string[]>) {
    this.isChangedAnyThing = true;
    moveItemInArray(this.menuColumns, event.previousIndex, event.currentIndex);
  }

  saveColumnsData(columnObj:any) {
    this.requestService.postTableSettings(this.tableSettingKey, columnObj)
      .subscribe(() => {
        this.closeModal();
        this.requestService.reloadCoulmn.next({ 'hard-reload': true });
      }, (error) => {
        console.log(error);
      });
  }

  closeModal() {
    this.closeModalEvent.emit();
  }


  // --------------------------- Newly Added Code For Column Preset ---------------------------
  /**
   * Restore to default preset
   */
 restore(event: Event) {
    var presetName = undefined;
    var isDefault = undefined;
    var tableFilterId = undefined
    this.onCheckboxChange(event, presetName, isDefault, tableFilterId);
  }
  
/**
 * Enable or Disable preset on checkbox change
 */
  onCheckboxChange(event: Event, presetName: any, isDefault: any, tableFilterId: any, pageName?: any) {
    this.requestService.showLoader();
    this.editPresetTableFilterIDGet = null;
    let responsepreset: any = localStorage.getItem("responsePresetName");
    if (responsepreset) {
      let parseData = JSON.parse(responsepreset);
      parseData = presetName === undefined ? "system preset" : presetName;
      localStorage.setItem("responsePresetName", JSON.stringify(parseData));
    }
    this.presetName = presetName === undefined ? "system preset" : presetName;
    isDefault = !this.isDefaultset
    this.filterTableID = tableFilterId
    let enablepresetObj = {
      tableFilterId: this.filterTableID,
      userId: localStorage.getItem('companyUserId'),
      companyId: this.storageService.getCompanyID(),
      page: this.tableSettingKey || pageName,
      presetName: this.presetName,
      isDefault: isDefault

    }
    this.requestService.enablePreset(enablepresetObj)
      .subscribe(() => {
        this.closeModal();
        this.applyColumn(false)
      });

    let presentName:any = localStorage.getItem("presetName")
    let presetNameDefault:any = localStorage.getItem("presetNameDefault")
    this.presetNameArray = JSON.parse(presentName)
    this.presetNameArrayDefault = JSON.parse(presetNameDefault)
    if (this.presetNameArray.length > 0) {
      this.presetNameArray.map((x:any) => {
        if (x.isDefault === true) {
          this.defaultPresetsName = x.presetName
        }
      })
    }
    if (this.presetNameArrayDefault.length > 0) {
      this.presetNameArrayDefault.map((x:any) => {
        if (x.isDefault === true) {

          this.defaultPresetsName = x.presetName

        }
      })
    }

    this.menuColumns = this.normalizeMenuColumns(this.menuColumns);
    this.isAllSelected = this.isAllselectSlected();
  }

/**
 * Apply column changes and save preset
 */
  applyColumn(val:any) {
    const normalizedMenuColumns = this.normalizeMenuColumns(this.menuColumns);
    const serializedMenuColumns = normalizedMenuColumns.map((column: any) => {
      if (!column || typeof column !== 'object') {
        return column;
      }
      const { cellTemplate, ...rest } = column;
      return { ...rest };
    });
        localStorage.setItem(`${this.tableSettingKey}-isViewBool`, JSON.stringify(val));
    localStorage.setItem("isViewBool", JSON.stringify(val));
    localStorage.setItem(`${this.tableSettingKey}-jsonColumnData`, JSON.stringify(serializedMenuColumns));
    localStorage.setItem("jsonColumnData", JSON.stringify(serializedMenuColumns));
    localStorage.setItem("editPresetTableFilterIDGet", JSON.stringify(this.editPresetTableFilterIDGet === undefined ? 0 : this.editPresetTableFilterIDGet));
    this.isChangedAnyThing = false; // Reset after changes are applied
    if (this.editPresetTableFilterIDGet === undefined || this.editPresetTableFilterIDGet === null) {
      this.columnObj.tableId = 0
    }
    else {
      this.columnObj.tableId = this.editPresetTableFilterIDGet
    }
    this.closeModal();
    this.reload.emit(this.menuColumns);
    this.columnObj.page = this.tableSettingKey;
    this.menuColumns.map((it:any) => delete it.cellTemplate);
    this.columnObj.json = this.menuColumns;
    this.columnObj.isDefault = this.isDefaultset;
    this.columnObj.filterTableId = this.filterTableID;
    this.columnObj.presetName = this.presetName;
    this.columnObj.isView = val;
    this.columnObj.tableId = this.editPresetTableFilterIDGet

    this.saveColumnsData(this.columnObj);
    
  }


  /**
   * Open Preset Name Modal for Add/Edit preset and fetch preset details if its edit action
   */
  presetNameModal(presetModalTemplate:any) {
    if (this.formBool === true) {
      this.openModal(presetModalTemplate);
      this.requestService.showLoader();
      this.requestService.getRequest(`tablefilter/editpreset?TableId=${this.editpresettableFilterId}`).subscribe(
        (response) => {
          this.formData = response;
          this.requestService.hideLoader();
        }, (error) => {
          this.toaster.error(`Something went wrong`, 'Opps!');
          console.log(error);
          this.requestService.hideLoader();
        });
    }
    else {

      this.openModal(presetModalTemplate);
    }
  }



/**
 * Save preset after add/edit and check preset name already exist or not
 */
   presetNameForm(formValue:any) {
    this.editPresetTableFilterIDGet = formValue.editPresetId
    let obj =
    {
      presetName: formValue.saveObj.presetName,
      companyId: this.storageService.getCompanyID(),
      userId: localStorage.getItem('companyUserId'),
      page: this.tableSettingKey,
      tableId: this.editPresetTableFilterIDGet === undefined ? 0 : this.editPresetTableFilterIDGet
    }
    this.requestService.checkPresetName(obj)
      .subscribe((response:any) => {
        if (response === true || formValue.saveObj.presetName.toLowerCase() === 'system preset') {
          this.toaster.error(`Preset Name Already Exist`, 'Opps!');
          return
        }
        if (response === false) {
          this.toaster.success('Preset saved Successfully ', 'Success');
          let responsepreset: any = localStorage.getItem("responsePresetName");
          if (responsepreset) {
            let parseData = JSON.parse(responsepreset);
            parseData = formValue.saveObj.presetName
            localStorage.setItem("responsePresetName", JSON.stringify(parseData));
          }
          this.presetName = formValue.saveObj.presetName;
          this.addAssetModal?.hide();
          this.applyColumn(false);
        }

      },
      );
  }


/**
 * Edit preset action on click of edit icon in preset list
 */
  editPreset(preset:any) {
    this.editpresettableFilterId = preset.tableFilterId
    this.formBool = !this.formBool
  }

  /**
   * Open Modal for add Asset
   */
  openModal(addAsset: TemplateRef<any>) {
    this.assetData = null;
    this.utilityService.modalConfig.class = "modal-md modal-dialog-centered";
    this.addAssetModal = this.modalService.show(
      addAsset,
      this.utilityService.modalConfig
    );
  }

  /**
   * Close Preset Modal on click of cancel button and reset form bool value to false
   */
  closeModalPreset(eventValue:any) {
    this.addAssetModal?.hide();
  }


  /**
   * Delete preset on click of delete icon in preset list with confirmation
   */
   deletePreset(val:any) {
    var tableFilterId = val

    Swal.fire({
      title: 'Are you sure?',
      text: "Are you sure you want to delete this preset?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.requestService.deletePresetRequest(`tablefilter/deletepreset?TableId=${tableFilterId}`).subscribe(
          () => {
            this.toaster.success('Preset deleted Successfully ', 'Success');
            this.editPresetTableFilterIDGet = val;
            this.applyColumn(false);
          }
        )
      } else {
      }
    });
    this.editPresetTableFilterIDGet = val
  }



/**
 * Normalize menu columns input to ensure it's always an array of column objects, regardless of whether the input is already an array or a JSON string.
 */
    private normalizeMenuColumns(menuColumns: any): any[] {
    if (Array.isArray(menuColumns)) {
      return menuColumns;
    }

    if (typeof menuColumns === 'string' && menuColumns.trim()) {
      try {
        const parsedColumns = JSON.parse(menuColumns);
        return Array.isArray(parsedColumns) ? parsedColumns : [];
      } catch {
        return [];
      }
    }

    return [];
  }

    /**
 * Check Is All Columns are not Selected
*/
  isAllColNotSlected(): boolean {
    return this.menuColumns?.every((column: any) => !column.isShowColumn);
  }
}
